import { useEffect, useMemo, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Panel } from '../../../components/panels/Panel';
import { Loader } from '../../../components/loading/Loader';
import { groupVeralliaDashboardDetections } from '../../../services/dashboard/verallia-dashboard-grouping-service';
import { filterVeralliaDashboardDetections } from '../../../services/dashboard/verallia-dashboard-service';
import { VeralliaDashboardFilters } from './components/VeralliaDashboardFilters';
import { VeralliaDashboardDetectionsTable } from './components/VeralliaDashboardDetectionsTable';
import { VeralliaDashboardNoData } from './components/VeralliaDashboardBlocks';

export const VeralliaDashboardDetections = ({ detections, isInfluxLoading, hasInfluxError, filters, onFiltersChange, page, onPageChange }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [navigation] = useState(() => location.state?.veralliaStatisticsJump ?? null);

  useEffect(() => {
    if (!location.state?.veralliaStatisticsJump) return;
    const nextState = { ...location.state };
    delete nextState.veralliaStatisticsJump;
    navigate(location.pathname + location.search + location.hash, { replace: true, state: Object.keys(nextState).length ? nextState : null });
  }, [location.pathname, location.search, location.hash, location.state, navigate]);

  const filteredDetections = useMemo(() => filterVeralliaDashboardDetections(detections, filters), [detections, filters]);
  const groupedCount = useMemo(() => groupVeralliaDashboardDetections(filteredDetections).length, [filteredDetections]);

  const handleFiltersChange = (nextFilters) => { onFiltersChange(nextFilters); };

  if (isInfluxLoading) return <Loader/>;

  return (
    <Panel title="PALETS DETECTADOS">
      <div className="mx-auto flex w-11/12 flex-col gap-4 py-6">
        {hasInfluxError ? <VeralliaDashboardNoData text="No se han podido cargar los datos."/> : (
          <>
            <VeralliaDashboardFilters detections={detections} value={filters} onChange={handleFiltersChange}/>
            <div className="text-xs font-semibold uppercase tracking-wider text-perception-gray-600">{groupedCount} detecciones encontradas{filteredDetections.length !== groupedCount ? ` (${filteredDetections.length} capturas)` : ''}</div>
            <VeralliaDashboardDetectionsTable detections={filteredDetections} page={page} onPageChange={onPageChange} jump={navigation}/>
          </>
        )}
      </div>
    </Panel>
  );
};
